import { Icon, type IconProps } from './Icon';

/** Avançar, e a seta de linha clicável. Substitui o `›`. */
export function ChevronRightIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m9 18 6-6-6-6" />
    </Icon>
  );
}
